const INITIAL_STATE = {
    users: {},
    userDetails:{},
    profile: null,
  };
  
  const applySetUsers = (state, action) => {
   return ({
      ...state,
      users: action.users
      
    });
  }

  const applyFetchUser = (state, action) => {
    return ({
      ...state,
      profile: action.userProfile
      
      });
  }
  
  function userReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case 'USERS_SET' : {
        return applySetUsers(state, action);
      }
      case 'FETCH_USER' : {
        return applyFetchUser(state, action);
      }
      default : return state;
    }
  }
  
  export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/user.js